import env from '../../env.json';
import dashboardBlobUrls from './index';

/**
 * Resolve dashboard announcement or external-link blob URL for the current APISource.
 * @param {'announcement' | 'externalLink'} key
 * @returns {string}
 */
export default function getDashboardBlobUrl(key) {
  return dashboardBlobUrls[env.APISource]?.[key] || '';
}
